import { theme } from '@digibee/beehive-ui';

export const Container = theme.styled('div', {
  marginTop: '$5'
});
